import {createRoot} from 'react-dom/client';
// Axios
import axios from 'axios';
import {Chart, registerables} from 'chart.js';
// Apps
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss';
import './_metronic/assets/sass/layout/errors/errors.scss';
import './_metronic/assets/sass/plugins.scss';
import './_metronic/assets/sass/style.react.scss';
import './app/common/styles/filterSelect.scss';
import './app/common/styles/typography.scss';
import {setupAxios} from './app/modules/auth/setupAxios';

//Auth
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {AppRoutes} from './app/routing/AppRoutes';
import {App} from './app/App';
import Index from './app/pages/form-new-account/Index';
import {NativeAuthProvider} from './app/modules/auth/native/NativeAuthProvider';

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios);
Chart.register(...registerables);

const {PUBLIC_URL} = process.env;

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <BrowserRouter basename={PUBLIC_URL}>
      <NativeAuthProvider>
        <Routes>
          <Route element={<App />}>
            <Route path="/public/create-account" element={<Index />} />
            <Route path={'/*'} element={<AppRoutes />} />
          </Route>
        </Routes>
      </NativeAuthProvider>
    </BrowserRouter>
  );
}
